module.exports = {
      id: "thodargal-usage",
      viewBox: "0 0 22.5 23.3",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#thodargal",
      toString: function () {
        return this.url;
      }
    }